import React, {FC} from "react"
import {withTheme, WithDefaultTheme} from "styled-components"

import ContactPreferencesSuccess from "@irati-web/account/src/containers/ContactPreferencesSuccess"
import AppContainer from "@irati/ui/src/AppContainer"

import ContactPreferencesNav from "./Nav"

interface Props extends WithDefaultTheme {}

const ContactPreferencesSuccessExternal: FC<Props> = ({theme}) => (
  <AppContainer mainBackground={theme.colors.utility.white}>
    <ContactPreferencesNav />
    <ContactPreferencesSuccess />
  </AppContainer>
)

export default withTheme(ContactPreferencesSuccessExternal)
